import $ from '../extend/jquery';
import PhotoSwipe from "photoswipe";

'use strict';
var App = {
    bind: function () {
    },
    userActions: function () {
        // Prevent closing the dorpdown, when clicked inside
        $(document).on('click', '.dropdown-menu', function (e) {
            e.stopPropagation() && $(this).hasClass('keep_open');
        });
        $(document).scroll(function () {
            if ($(document).scrollTop() >= 50) {
                $('.user-actions .user-icon').removeClass('open');
            }
        });
    },
    mainMenu: function () {
        // TODO: menu hover stylings and poistioning fix
    },
    zoomLink: function () {
        $('.zoom-link').hover(function () {
            $('.zoom-wrapper').addClass('zoom-active');
        }, function () {
            $('.zoom-wrapper').removeClass('zoom-active');
        });
    },
    initPswp: function () {
        var $pswp = $('.pswp')[0];
        var image = [];
        $('.picture').each(function () {
            var $pic = $(this),
                getItems = function () {
                    var items = [];
                    $pic.find('a').each(function () {
                        var $href = $(this).attr('href'),
                            $size = $(this).data('size').split('x'),
                            $width = $size[0],
                            $height = $size[1];
                        var item = {
                            src: $href,
                            w: $width,
                            h: $height
                        };
                        items.push(item);
                    });
                    return items;
                };
            var items = getItems();
            $.each(items, function (index, value) {
                image[index] = new Image();
                image[index].src = value['src'];
            });
            $pic.on('click', 'figure', function (event) {
                event.preventDefault();
                var $index = $(this).index();
                var options = {
                    dataSource: items,
                    index: $index,
                    bgOpacity: 0.65,
                    showHideOpacity: true,
                    shareEl: false
                };

                const pswp = new PhotoSwipe(options);
                pswp.init();
            });
        });
    },
    cardFlipping: function () {
        $('.card').click(function () {
            $(this).toggleClass('flipped');
        });
    },
    filterChecks: function () {
        $('.filter-cards').on('change', 'input[type=checkbox]', function (e) {
            $('.team-wrapper').find("[data-section=section-" + this.value + "]").slideToggle();
        });
        $('.filter-toggle').click(function () {
            $(this).toggleClass('is-active');
        });
        $('.filter-buttons button').click(function () {
            $(this).toggleClass('clicked')
            $('.team-wrapper').find("[data-section=section-" + this.value + "]").slideToggle();
        });
    },
    circleProgress: function () {
        /*
         * Init circle progress plugin with base settings
         */
        if ($(window).width() < 977) {
            $('.circle').circleProgress({
                lineCap: 'round',
                fill: {color: '#C40003'},
                emptyFill: 'transparent',
                size: 70
            });
        } else {
            $('.circle').circleProgress({
                lineCap: 'round',
                fill: {color: '#C40003'},
                emptyFill: 'transparent',
                size: 100
            });
        }

        function recaclCircles() {
            if ($(window).width() < 977) {
                $('.circle').circleProgress({
                    size: 70,
                    animation: false
                });
            } else {
                $('.circle').circleProgress({
                    size: 100,
                    animation: false
                });
            }
        };var resizeTimer;
        $(window).resize(function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(recaclCircles, 100);
        });
        // Reinit on tab change
        $('.player-nameblock .player-tab-nav a').click(function () {
            $('.player-stats .tab-pane').find('.circle').circleProgress('redraw');
        });
    },
    museumActions: function () {
        // Musaeum page actions
        $('.dateselect > ul > li > a').click(function (e) {
            e.preventDefault();
            $('.dateselect > ul > li > a').not(this).removeClass('selected');
            $(this).toggleClass('selected');
        });
        // Sticky date slector on desktops
        if ($(window).width() > 977) {
            $(".dateselect > ul").stick_in_parent({recalc_every: 1});
        }

        function museumDecors() {
            if ($(window).width() > 977) {
                $(".dateselect > ul").stick_in_parent({recalc_every: 1});
            } else {
                $(".dateselect > ul").trigger("sticky_kit:detach");
            }
        };var resizeTimer;
        $(window).resize(function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(museumDecors, 100);
        });
        // Scrollable
    },
    matchPage: function () {
        $(".star-wrapper a").hover(function () {
            $(this).prevAll().addClass('select-progress');
        }, function () {
            $(this).prevAll().removeClass('select-progress');
        });
    },
    fansPage: function () {
        $('a.btn-filters').click(function (e) {
            e.preventDefault();
            $('.drp').toggleClass('open');
        });
    },
    anchorScroll: function () {
        $('*[data-scrolling]').on('click', function (e) {
            var scrollTarget = $(this).attr('data-scrolling');
            if (scrollTarget !== '') {
                var offsetTop = $(scrollTarget).offset().top;
                var offset;
                offset = offsetTop - 60;
                $('html, body').animate({
                    scrollTop: offset
                }, 600);
            }
            e.preventDefault();
        });
    },
    acceptPrivacy: function () {
        function setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        $(document).on('click', '.accept-privacy', function () {
            setCookie('privacyAgreed', 1, 14);
            $('.cookie-cnt').hide();
        });
    },
    subPagePaginator: function () {
        $(document).on('click', '.subpage-paginator', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var url = $(this).attr("href");
            $.ajax({
                type: "POST",
                url: url,
                data: {},
                crossDomain: true,
                headers: {'X-Requested-With': 'XMLHttpRequest'},
                success: function (ret) {
                    $('#subpage-articles').replaceWith(ret).promise().done(function () {
                        $('#subpage-articles article').matchHeight();
                    });
                }
            });
        });
    },
    getCookie: function (name) {
        let cookie = {};
        document.cookie.split(';').forEach(function (el) {
            let split = el.split('=');
            cookie[split[0].trim()] = split.slice(1).join("=");
        })
        return cookie[name];
    },
    init: function () {
        App.subPagePaginator();
        App.acceptPrivacy();
        App.userActions();
        App.userActions();
        App.mainMenu();
        App.zoomLink();
        App.initPswp();
        App.cardFlipping();
        App.filterChecks();
        App.circleProgress();
        App.museumActions();
        App.matchPage();
        App.fansPage();
        App.anchorScroll();
    }
};

function AppAjaxEventLayerOff() {
    $(document).off('ajaxError');
    $(document).off('ajaxComplete');
    $(document).off('ajaxSend');
}

function AppAjaxEventLayerInit() {
    var selector = '#ajax_operations';
    $(document).ajaxError(function () {
        //console.log("ajax-error");
        $(selector).fadeOut(500);
    });
    $(document).ajaxComplete(function () {
        //console.log("ajax-complete");
        $(selector).fadeOut(500);
    });
    $(document).ajaxSend(function () {
        //console.log("ajax-start");
        $(selector).fadeIn(500);
    });
}

function scrollToAnchor(element, topOffset) {
    var e = $(element);
    if (topOffset) {
        $('html,body').animate({scrollTop: (e.offset().top + topOffset)}, 1000);
    } else {
        $('html,body').animate({scrollTop: e.offset().top}, 1000);
    }
}

function AppVoterInit() {
    var selector = '.voter-btn';
    var voterSelector = '#voter-container';
    $(document).on('click', selector, function (e) {
        var p = $(this).parent();
        var radio = p.find('input[type="radio"]:checked');
        if (radio.length) {
            var url = radio.attr("data-url");
            var voteOptionId = radio.val();
            $.ajax({
                type: "POST",
                url: url,
                data: {voteOptionId: voteOptionId},
                crossDomain: true,
                headers: {'X-Requested-With': 'XMLHttpRequest'},
                success: function (ret) {
                    $(voterSelector).replaceWith(ret);
                }
            });
        } else {
            // no radio selected
        }
    });
}

function AppRaterInit() {
    var selector = '.vote-star';
    var container = '#rater-container';
    $(document).on('click', selector, function (e) {
        var gameId = $(this).attr("data-game");
        var playerId = $(this).attr("data-player");
        var rate = $(this).attr("data-rate");
        var url = $(this).attr("data-url");
        var row = $(selector + '[data-player="' + playerId + '"]');
        row.removeClass('select-progress');
        $(this).addClass('select-progress');
        $.ajax({
            type: "POST",
            url: url,
            data: {
                gameId: gameId,
                playerId: playerId,
                rate: rate
            },
            crossDomain: true,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (ret) {
                $(container).replaceWith(ret);
            }
        });
    });
}

function AppAdvertiseInit() {
    var selector = '.advertise-click-counter';
    $(document).on('click', selector, function (e) {
        e.preventDefault();
        var url = '/advertise/ajax/click';
        var advertiseId = $(this).attr("data-id");
        $.ajax({
            type: "POST",
            url: url,
            data: {advertiseId: advertiseId},
            crossDomain: true,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (ret) {
                if (ret.success) {
                    window.open(ret.href);
                }
            }
        });
    });
}

function AppGallerySwitcherInit() {
    var selector = '.toggle-gallery';
    var wrapperSelector = '.included-gallery';
    $(document).on('click', selector, function (e) {
        $(selector).removeClass('btn-primary').addClass('btn-default');
        $(this).addClass('btn-primary');
        var dataTab = $(this).attr("data-tab");
        var wrappers = $(wrapperSelector);
        wrappers.each(function () {
            var w = $(this);
            if (w.attr("data-tab") != dataTab) {
                // close this
                w.hide();
            } else {
                w.show();
            }
        });
    });
}

function AppFancyBoxInit() {
    var selector = '.fancybox';
    $(selector).fancybox({
        openEffect: 'elastic',
        closeEffect: 'elastic',
    });
}

function AppFancyBox2Init() {
    var selector = '.included-gallery-thumbs-item';
    var bigSelector = '.included-gallery-opening';
    var itemWidth = $(selector).outerWidth(true) + 3;
    // big image bring up the counted thumbnail click event
    $(bigSelector).click(function () {
        var cnt = $(this).attr("data-cnt");
        var type = $(this).attr("data-type");
        // console.log(selector + '[data-cnt="' + cnt + '"][data-type="' + type + '"]');
        $(selector + '[data-cnt="' + cnt + '"][data-type="' + type + '"]').click();
    });
    $(selector).fancybox({
        padding: 5,
        margin: 5,
        prevEffect: 'fade',
        nextEffect: 'fade',
        helpers: {
            title: {
                type: 'inside'
            },
            thumbs: {
                width: 125,
                height: 75,
            }
        },
        'afterClose': function () {
            var e = this.element;
            var cnt = e.attr('data-cnt');
            var type = e.attr('data-type');
            var bg = e.css('background-image');
            bg = bg.replace('gallery_folder-cropped', 'hd');
            $(selector + '[data-type="' + type + '"]').css({'left': ((cnt - 1) * itemWidth * -1)});
            $(bigSelector + '[data-type="' + type + '"]').css('background-image', bg);
            $(bigSelector + '[data-type="' + type + '"]').attr('data-cnt', cnt);
        }
    });
}

function AppNewsletterSubmitInit() {
    var selector = '#newsletter';
    $(selector).submit(function () {
        var url = $(selector).attr('action');
        $.ajax({
            type: "POST",
            url: url,
            data: $(selector).serialize(),
            crossDomain: true,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (ret) {
                if (ret.success) {
                    dialogBox('Sikeres feliratkozás', ret.msg);
                } else {
                    dialogBox('Sikertelen feliratkozás', ret.msg);
                }
            }
        });
        return false; // avoid to execute the actual submit of the form.
    });
}

function AppBlockOpenInit() {
    var selector = '.open-block';
    $(document).on('click', selector, function () {
        var block = $(this).attr('data-block');
        if ($(block).is(":visible")) {
            $(block).slideUp("fast");
            return;
        }
        $(block).slideDown("fast");
    });
}

function AppDropdownBehaveInit() {
    var navbarSelector = '.navbar-dvtk .navbar-toggle';
    var dropdownSelector = '.dropdown a';
    if ($(navbarSelector).is(":visible")) {
        $(document).on('click', dropdownSelector, function () {
            window.scrollTo(0, 0);
        });
        $(document).on('click', navbarSelector, function () {
            window.scrollTo(0, 0);
        });
    }
}

function AppDropdownMouseOverInit() {
    var selector = '.dropdown-mouse-over > span';
    var dropdownSelector = '.dropdown-menu';
    $(document).on('mouseover', selector, function () {
        var p = $(this).parent();
        var expanded = p.attr("aria-expanded");  // got string back
        if (expanded == "false") {
            // was closed, amulate click on it
            p.click();
        }
    });
    $(document).on('mouseleave', dropdownSelector, function () {
        if ($(this).hasClass('keep_open')) {
            return;
        }
        var p = $(this).parent();
        var b = p.find(".dropdown-toggle");
        b.click();
    });
}

function dialogBox(title, msg, timeout) {
    var fn = function () {
        $('#flashes_wrapper').html(msg).dialog({
            modal: true,
            closeOnEscape: true,
            title: title,
            closeText: "X",
            open: function () {
                jQuery('.ui-widget-overlay').bind('click', function () {
                    jQuery('#flashes_wrapper').dialog('close');
                });
            }
        });
    };
    if (timeout) {
        setTimeout(fn, timeout);
    } else {
        fn.call();
    }
}

function IndexsliderUrlInit() {
    var selector = '.carousel-href';
    $(document).on('click', selector, function () {
        var url = $(this).attr("data-url");
        location.href = url;
    });
}

function IndexCarouselInit() {
    var indicatorSelector = '.carousel-indicators li';
    var carouselSelector = '.carousel';
    $(carouselSelector).carousel();
    $(indicatorSelector).on("mouseover", function () {
        var control = $(this);
        var dataSlideTo = parseInt(control.attr("data-slide-to"));
        $(carouselSelector).carousel(dataSlideTo);
    });
    $(indicatorSelector).on("click", function () {
        var control = $(this);
        var dataSlideTo = control.attr("data-slide-to");
        var slide = $('.carousel-href:eq(' + dataSlideTo + ')');
        var url = slide.attr('data-url');
        location.href = url;
    });
}

function IndexInitForm() {
    var selector = ".ajax-form";
    $(document).on("submit", selector, function (e) {
        var formObj = $(this);
        var formURL = formObj.attr("data-url");
        if (formURL == "undefined") {
            // try to get url from action
            formURL = formObj.attr("action");
        }
        var formData = new FormData(this);
        $.ajax({
            url: formURL,
            type: formObj.attr("method"),
            data: formData,
            mimeType: (formObj.attr("enctype") ? formObj.attr("enctype") : false),
            contentType: false,
            cache: false,
            processData: false,
            crossDomain: true,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (ret, textStatus, jqXHR) {
                // console.log(ret);
                // console.log(textStatus);
                var r = (typeof ret == 'object' ? ret : $.parseJSON(ret));
                if (r && r.success) {
                    dialogBox('Sikeres művelet', r.msg);
                } else {
                    dialogBox('Hiba', r.msg);
                }
            }, //error: function (jqXHR, textStatus, errorThrown) {}
        });
        e.preventDefault(); //Prevent Default action.
    });
}

function IndexInitLogin() {
    var selector = '#login-form';
    $(selector).submit(function (e) {
        e.preventDefault();
        var url = $(selector).attr('action');
        $.ajax({
            type: "POST",
            url: url,
            data: $(selector).serialize(),
            crossDomain: true,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (ret) {
                if (ret.success) {
                    location.href = ret.redirect;
                } else {
                    dialogBox('DVTK', ret.msg);
                }
            }
        });
    });
}

function IndexMenuExtInit() {
    var selector = '#main-menu ul li a';
    var sportsMenuSelector = '#sports-menu';
    var dropdownSelector = '.open';
    $(document).on("mouseover", selector, function () {
        if ($(sportsMenuSelector).is(':visible')) {
            $(dropdownSelector).click();
        }
    });
}

function IndexVoterLogin() {
    var userSelector = '#user';
    $(userSelector).click();
}

function IndexAppAdvertInit() {
    var tt = new Date().getTime();
    var container = $('#app-downloader');
    $(window).load(function () {
        AppAjaxEventLayerOff();
        $.ajax({
            type: "GET",
            url: '/app-advert/' + tt,
            data: {},
            crossDomain: true,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (ret) {
                container.html(ret);
            }
        });
        AppAjaxEventLayerInit();
    });
}

function IndexCookiesAcceptInit() {
    var tt = new Date().getTime();

    $(window).load(function () {
        if (!App.getCookie("privacyAgreed")) {
            var cookiebarTpl = '<div class="cookie-cnt">\n' +
                '    A weboldalon cookie-kat használunk, hogy biztonságos böngészés mellett a legjobb felhasználói élményt nyújthassuk. <a href="/adatvedelem" target="_blank">Részletes leírás</a>\n' +
                '    <button class="btn btn-primary accept-privacy">Elfogadom</button>\n' +
                '  </div>'
            $('footer').append(cookiebarTpl);
        }
    });
}

function IndexUserMenuInit() {
    var c = $('.trigger-logreg');
    $(window).load(function () {
        AppAjaxEventLayerOff();
        var isAuthenticated = App.getCookie('APP_USER_AUTHENTICATED');

        $.ajax({
            data: {},
            url: isAuthenticated ? '/felhasznalo/trigger/authenticated' : '/felhasznalo/trigger/unauthenticated',
            type: "GET",
            crossDomain: true,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (ret) {
                c.prepend(ret);
            }
        });
        AppAjaxEventLayerInit();
    });
}

function InitJumpToInit() {
    var selector = '[data-jumpto^="/"]';
    $(document).on('click', selector, function (event) {
        var url = $(this).attr('data-jumpto');
        window.location = url;
        event.stopPropagation();
    });
}

function InitStickyHandle() {
    var popupHeight = 0;
    var popup = $('.popup');
    var navbarSelector = '.navbar-dvtk .navbar-toggle';
    if (popup.length) {
        popupHeight = popup.height();
    }
    if (!popup.is(':visible')) {
        popupHeight = 0;
    }
    var menuHeight = menu.height(); // 160
    if ($(window).scrollTop() > origOffsetY && popup.is(':visible')) {
        $('#sticky-gag').css('height', menuHeight + 'px');
    } else {
        $('#sticky-gag').css('height', 0 + 'px');
    }
    if ($(window).scrollTop() > popupHeight) {
        menu.addClass('sticky-menu');
        $('.masthead__bottom').hide();
    } else {
        menu.removeClass('sticky-menu');
        $('.masthead__bottom').show();
    }
    if ($('.navbar-collapse').hasClass('in')) {
        var collapsedHeight = $('.navbar-collapse').height();
        if (collapsedHeight < $(window).scrollTop()) {
            $('.navbar-collapse').removeClass('in');
        }
    }
}

function InitTeamPlayerDetails() {
    $("[data-details-url]").click(function () {
        window.location = $(this).data("details-url");
    });
}

function InitPopupClose() {
    var selector = '.popup-close';
    var popupSelector = '.popup';
    $(document).on('click', selector, function () {
        AppAjaxEventLayerOff();
        $(popupSelector).slideUp('fast');
        var url = $(selector).attr('data-url');
        $.ajax({
            type: "POST",
            url: url,
            data: {},
            crossDomain: true,
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            success: function (ret) {
                AppAjaxEventLayerInit();
                origOffsetY = 0; // becouse of popup
            }
        });
    });
}

function InitPopupModal() {
    var selector = '#popupModal';
    var myModal = $(selector);
    if (myModal.length > 0) {
        myModal.modal({
            show: true,
            keyboard: true,
            backdrop: 'static',
        });
        window.scrollTo(0, 0);
    }
}

function InitSearchAutocomplete() {
    let autoCompleteField = $("#search-autocomplete");

    if (autoCompleteField) {
        let url = autoCompleteField.data('url');

        autoCompleteField.autocomplete({
            source: url, delay: 500, minLength: 3, open: function (event, ui) {
                $('.ui-autocomplete').scrollTop(0);
            }, focus: function (event, ui) {
                $("#search-autocomplete").val(ui.item.name);
                return false;
            }, select: function (event, ui) {
                window.location = ui.item.url;
            }, close: function (event, ui) {
                $("#search-autocomplete").val("");
            }
        }).autocomplete("instance")._renderItem = function (ul, item) {
            return $("<li>").append("<a href='" + item.url + "'>" + (item.articleLi ? item.articleLi : item.name) + "</a>").appendTo(ul);
        };
    }
}

function InitDialogBox(content = "") {
    let flashMessage = $('.flash-message');

    if (flashMessage) {
        let msg = flashMessage.data('msg'),
            name = flashMessage.data('name');

        if (msg && msg.length > 0) {
            dialogBox(
                (name ? name : 'DVTK'),
                msg,
                3000
            );
        }
    }
}

function initParkContentHeightMatcher() {
    /* original had typo as well*/
    let parkContent = $('.park-contet');

    if (parkContent) {
        parkContent.matchHeight();
    }

    let parkSidebar = $('.park-sidebar');

    if (parkSidebar) {
        parkSidebar.matchHeight();
    }
}

var menu = null;
var origOffsetY = null;
$(document).ready(function () {
    console.log("Frontend: init ready");
    menu = $('.masthead');
    origOffsetY = menu.offset().top;
    // origOffsetY = 0; // becouse of popup
    document.onscroll = InitStickyHandle;
    App.init();
    AppAjaxEventLayerInit();
    AppVoterInit();
    AppAdvertiseInit();
    AppGallerySwitcherInit();
    AppFancyBoxInit();
    AppNewsletterSubmitInit();
    AppRaterInit();
    AppBlockOpenInit();
    AppDropdownMouseOverInit();
    AppFancyBox2Init();
    IndexsliderUrlInit();
    IndexCarouselInit();
    IndexInitForm();
    IndexInitLogin();
    IndexMenuExtInit();
    IndexCookiesAcceptInit();
    IndexUserMenuInit();
    InitJumpToInit();
    InitStickyHandle();
    InitTeamPlayerDetails();
    InitPopupClose();
    InitPopupModal();
    AppDropdownBehaveInit();
    IndexAppAdvertInit();
    InitSearchAutocomplete();
    InitDialogBox();
    initParkContentHeightMatcher();
});
